import { render, staticRenderFns } from "./options-criteria-color.vue?vue&type=template&id=643c6c52&"
import script from "./options-criteria-color.vue?vue&type=script&lang=js&"
export * from "./options-criteria-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports